import { AxiosResponse } from "axios";
import { toast } from "react-toastify";

import axios from "../axiosServices";

async function GetProdutos(params?: any): Promise<AxiosResponse> {
  try {
    const response = await axios({
      method: "get",
      url: `locais/mobile/produtos/v1?${params}`,
    });
    return response;
  } catch (error: any) {
    if (error.response.status !== 401) toast.error("Erro ao listar produtos.");
    return error;
  }
}

async function GetProdutosDetail(params?: any): Promise<AxiosResponse> {
  try {
    const response = await axios({
      method: "get",
      url: `locais/mobile/produtos/detalhes/v1?${params}`,
    });
    return response;
  } catch (error: any) {
    if (error.response.status !== 401)
      toast.error("Erro ao exibir dados do produto.");
    return error;
  }
}

async function GetZonasEmpreendimentos(): Promise<AxiosResponse> {
  try {
    const response = await axios({
      method: "get",
      url: `locais/mobile/zonas-empreendimentos/v1`,
    });
    return response;
  } catch (error: any) {
    if (error.response.status !== 401) toast.error("Erro ao listar zonas.");
    return error;
  }
}

async function GetBairrosEmpreendimentos(): Promise<AxiosResponse> {
  try {
    const response = await axios({
      method: "get",
      url: `locais/mobile/bairros-empreendimentos/Regional/v1`,
    });
    return response;
  } catch (error: any) {
    if (error.response.status !== 401) toast.error("Erro ao listar bairros.");
    return error;
  }
}

export default {
  GetProdutos,
  GetProdutosDetail,
  GetZonasEmpreendimentos,
  GetBairrosEmpreendimentos,
};
